import { render, staticRenderFns } from "./SearchFacetModal.vue?vue&type=template&id=18e832f2&scoped=true&"
import script from "./SearchFacetModal.vue?vue&type=script&lang=ts&"
export * from "./SearchFacetModal.vue?vue&type=script&lang=ts&"
import style0 from "./SearchFacetModal.vue?vue&type=style&index=0&id=18e832f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e832f2",
  null
  
)

export default component.exports